import { render, staticRenderFns } from "./system-setup.vue?vue&type=template&id=a9aba7c0&scoped=true"
import script from "./system-setup.vue?vue&type=script&lang=js"
export * from "./system-setup.vue?vue&type=script&lang=js"
import style0 from "./system-setup.vue?vue&type=style&index=0&id=a9aba7c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9aba7c0",
  null
  
)

export default component.exports